import { SchemaDefinition } from './serializeFeedbackUIToLC';

/**
 * Validates that output schema property keys have no whitespace and no capital letters
 * @param keys - Array of property keys to validate
 * @returns Object with isValid boolean and invalidKeys array
 */
export function validateOutputSchemaKeys(keys: string[]): {
  isValid: boolean;
  invalidKeys: string[];
} {
  const invalidKeys: string[] = [];

  for (const key of keys) {
    // Check for whitespace
    if (/\s/.test(key)) {
      invalidKeys.push(key);
      continue;
    }

    // Check for capital letters
    if (/[A-Z]/.test(key)) {
      invalidKeys.push(key);
      continue;
    }
  }

  return {
    isValid: invalidKeys.length === 0,
    invalidKeys,
  };
}

/**
 * Validates output schema property keys from a schema definition
 * @param schema - Schema definition to validate
 * @returns Object with isValid boolean and invalidKeys array
 */
export function validateSchemaPropertyKeys(schema: SchemaDefinition | null): {
  isValid: boolean;
  invalidKeys: string[];
} {
  if (!schema || !schema.properties) {
    return { isValid: true, invalidKeys: [] };
  }

  const keys = Object.keys(schema.properties);
  return validateOutputSchemaKeys(keys);
}

/**
 * Formats the validation error message for display
 * @param invalidKeys - Array of invalid keys
 * @returns Formatted error message
 */
export function formatValidationErrorMessage(invalidKeys: string[]): string {
  const keyList = invalidKeys.map((key) => `"${key}"`).join(', ');
  return `Output schema keys cannot contain whitespace or capital letters. Invalid keys: ${keyList}`;
}
